/**
 * Labstep
 *
 * @module components/ProtocolValue/Form/ShowEdit/Resource
 * @desc Search and select a Resource for a ProtocolValue
 */

import { filters } from 'labstep-web/components/ProtocolValue/Form/ShowEdit/Resource/constants';
import { ResourceInfoPreview } from 'labstep-web/components/Resource/Info/Preview';
import { FormShowEditSearchSelectModal } from 'labstep-web/core/Form/ShowEdit/SearchSelect/Modal';
import columnDefs from 'labstep-web/grid/SearchModal/coldefs/resource';
import { Resource } from 'labstep-web/models/resource.model';
import type React from 'react';
import type { IProtocolValueFormShowEditResourceProps } from './types';

export const ProtocolValueFormShowEditResource: React.FC<
  IProtocolValueFormShowEditResourceProps
> = ({ protocolValue, ...rest }) => (
  <FormShowEditSearchSelectModal
    childEntityName={Resource.entityName}
    parentEntity={protocolValue}
    optimistic={false} // This is because resource_item_id can become null
    children={
      protocolValue.resource ? (
        <ResourceInfoPreview
          resource={protocolValue.resource}
          {...rest}
        />
      ) : undefined
    }
    createBody={
      protocolValue.is_output
        ? protocolValue.resource_template
          ? {
              template_id: protocolValue.resource_template.id,
              protocol_value_origin_id: protocolValue.guid,
            }
          : protocolValue.guid
            ? { protocol_value_origin_id: protocolValue.guid }
            : undefined
        : protocolValue.resource_template
          ? { template_id: protocolValue.resource_template.id }
          : undefined
    }
    creatable
    searchProps={{
      filters,
      params: protocolValue.resource_template
        ? {
            template_id: protocolValue.resource_template.id,
          }
        : undefined,
    }}
    actionComponentProps={{
      type: 'text',
      text: `Restrict to specific ${Resource.getHumanReadableEntityName()}`,
      elementProps: {
        placeholder: true,
      },
      dataCy: 'components/ProtocolValue/Form/ShowEdit/Resource',
    }}
    columnDefs={columnDefs(protocolValue.resource_template)}
  />
);
